import type { UserStatus } from '@/types/user'

export type AccountStatus = 'inactive' | 'deactivated' | null

export function getAccountStatus(status: UserStatus): AccountStatus {
  if (status === 'INACTIVE') return 'inactive'
  if (status === 'DEACTIVATED') return 'deactivated'
  return null
}
